import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@src/store';
import type { Contact } from '@src/types/shared/contact';
import type { DateParams } from '@src/types/shared/date_params';
import { createSimpleSliceReducers } from '../helpers/slice_helpers';

const initialState: Contact = {
  name: '',
  nameFurigana: '',
  telephone: '',
  email: '',
  birthDay: {
    year: '',
    month: '',
    day: '',
  },
};

const resumeContactSlice = createSlice({
  name: 'resumeContact',
  initialState,
  reducers: {
    ...createSimpleSliceReducers<Contact>(),
    updateName(state: Contact, action: PayloadAction<string>) {
      state.name = action.payload;
    },
    updateNameFurigana(state: Contact, action: PayloadAction<string>) {
      state.nameFurigana = action.payload;
    },
    updateTelephone(state: Contact, action: PayloadAction<string>) {
      state.telephone = action.payload;
    },
    updateEmail(state: Contact, action: PayloadAction<string>) {
      state.email = action.payload;
    },
    updateBirthday(state: Contact, action: PayloadAction<DateParams>) {
      state.birthDay = action.payload;
    },
  },
});

export const {
  update: updateContact,

  updateName,
  updateNameFurigana,
  updateTelephone,
  updateEmail,
  updateBirthday,
} = resumeContactSlice.actions;

// Selectors
export const selectContact = (state: RootState) => state.resumeContact;

export default resumeContactSlice.reducer;
